import { put } from "../../request";
import type { Id } from "../../../lib/Id";

const mute = (id: Id): Promise<Record<string, never>> =>
  put(`/api/listings/${id}/mute`);

export default mute;
